<template>
  <div class="successCaseContent1">
    <div class="success-top">
      <Row>
        <Col span="2"></Col>
        <Col span="10">
          <div class="top-content">
            <h2>天鸿在线精品案例</h2>
            <p>天鸿在线依托完善的解决方案和优秀的产品服务，近年助力政企单位、园区、加工制造型企业、高校和大型商业综合体等大量客户，推进智能化、智慧化信息化建设，得到了客户一致好评，沉淀了众多精品案例。</p>
          </div>
        </Col>
        <Col span="12"></Col>
      </Row>
    </div>

    <div class="succes-center" >
      <Row>
        <Col span="2"></Col>
        <Col span="22">
          <div class = "center">
            <div class="content">
            <Tabs>
              <TabPane label="企业">
                <SuccessCarousel/>

              </TabPane>
              <TabPane label="政府机构">
                <SuccessEnterprise/>

              </TabPane>
              <TabPane label="教育">
                <SuccessEducate/>

              </TabPane>
              <TabPane label="医疗">

              </TabPane>
            </Tabs>
            </div>
          </div>
        </Col>
		<Col span="2"></Col>
      </Row>

    </div>
  </div>
</template>

<script>
  import SuccessCarousel from '../../util/SuccessCarousel.vue'
  import SuccessEducate from '../../util/SuccessEducate.vue'
  import SuccessEnterprise from '../../util/SuccessEnterprise.vue'
  export default {
    name: 'SuccessCaseContent1',
    components:{SuccessCarousel,SuccessEducate,SuccessEnterprise}
  }

</script>

<style lang="less">
  .successCaseContent1{
      background-size: 100% 100%;
      background-image: url(../../assets/img/cgan-bj.jpg);
      background-repeat: no-repeat;
    .success-top{
      padding-top: 1.5rem;
      padding-bottom: 1rem;
      .top-content{
        padding-left: 0.5rem;
        h2{
          margin-bottom: 0.2rem;
          	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
        }
        p{
          margin-bottom: 0.1rem;
          	font-family: MicrosoftYaHeiLight;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
        }
      }

    }
    .succes-center{
      .center{
        padding-left: 0.5rem;
        padding-right: 3.9rem;
        .content{
          background: rgba(255,255,255,0.1);
          .ivu-tabs-nav-scroll {
            margin-left: 8%;
          }
          .ivu-tabs-nav .ivu-tabs-tab{
            padding: 0.2rem 70px;
            color: #ffffff;
            }
          .ivu-tabs-ink-bar{
            background: #ffffff;
          }
          .ivu-tabs-nav .ivu-tabs-tab-active{
            color: #ffffff;
          }
          .ivu-tabs{
            // color: #ffffff;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/success-case-content/SuccessCaseContent1.vue